import { ArrowSquareOut, Wrench } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export const FixGuide = ({ id, guide }) => (
  <div className="mt-4 border border-[#F97316]/30 bg-[#F97316]/5 rounded-md p-4" data-testid={`exception-guide-${id}`}>
    <div className="flex items-center gap-2 text-sm font-semibold text-[#F97316]">
      <Wrench weight="bold" /> How to fix
      <span className="text-xs font-normal text-zinc-400">· {guide.who}{guide.minutes ? ` · about ${guide.minutes} min` : ""}</span>
    </div>
    <ol className="list-decimal ml-5 mt-2 space-y-1 text-sm text-zinc-300">
      {guide.steps.map((s, i) => <li key={i}>{s}</li>)}
    </ol>
    {guide.link && (
      <Button asChild size="sm" variant="secondary" className="mt-3 gap-1.5" data-testid={`exception-guide-link-${id}`}>
        <a href={guide.link} target={guide.link.startsWith("http") ? "_blank" : undefined} rel="noreferrer">{guide.link_label} <ArrowSquareOut /></a>
      </Button>
    )}
  </div>
);
